import type { Toast as ToastType } from "~/features/orders/types";

type ToastProps = Readonly<{
  toast: ToastType;
}>;

export function Toast({ toast }: ToastProps) {
  if (!toast) return null;

  const borderColor =
    toast.type === 'success'
      ? 'var(--success-green)'
      : toast.type === 'error'
        ? '#dc3545'
        : toast.type === 'warning'
          ? 'var(--warning-amber)'
          : 'var(--primary-blue)';

  return (
    <div
      style={{
        position: 'fixed',
        top: 'calc(var(--app-nav-header-height) + var(--app-nav-height) + 12px)',
        right: 24,
        zIndex: 1000,
        background: 'white',
        padding: 16,
        borderRadius: 8,
        boxShadow: '0 4px 16px rgba(0,0,0,0.2)',
        minWidth: 320,
        borderLeft: `4px solid ${borderColor}`,
        animation: 'slideIn 0.3s ease',
      }}
    >
      <div style={{ fontSize: 14, fontWeight: 500 }}>{toast.message}</div>
    </div>
  );
}
